import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
    consoleResponse: '',
    consoleType: 'single',
    isProcessing: false
}

const name = 'console'
const parentSelector = state => state?.[name]

const consoleSlice = createSlice({
    name: name,
    initialState: initialState,
    reducers: {
        resetConsole: () => {
            return initialState;
        },
        setConsoleResponse: (state, action) => {
            return {
                ...state,
                consoleResponse: action.payload,
            };
        },
        setConsoleProcessing: (state, action) => {
            return {
                ...state,
                isProcessing: action.payload,
            };
        },
        setConsoleType: (state, action) => {
            return {
                ...state,
                consoleType: action.payload,
            };
        },
    },
});


const getConsoleResponse = createSelector(parentSelector, state => {
    return state?.consoleResponse
})

const getConsoleType = createSelector(parentSelector, state => {
    return state?.consoleType
})

const getConsoleProcessing = createSelector(parentSelector, state => {
    return state?.isProcessing
})


const actions = {
    ...consoleSlice.actions
}

const selectors = {
    getConsoleResponse,
    getConsoleType,
    getConsoleProcessing
}

export const consoleActions = { actions, selectors }


export default consoleSlice;